import { Checkbox as MotiliUICheckbox, CheckboxProps } from '@motili/ui';

interface CheckboxWrapperProps extends Partial<CheckboxProps> {
    color?: string;
    style?: any;
    dataTestId?: string;
}

const Checkbox = (props: CheckboxWrapperProps) => {
    const { color, style, ...otherProps } = props;
    const updatedProps = {
        color,
        style,
        ...defaultProps,
        ...otherProps,
    };
    return <MotiliUICheckbox {...updatedProps} />;
};

const defaultProps: CheckboxProps = {
    name: '',
    checked: false,
    value: '',
    id: 'default-checkbox-id',
    label: '',
    onChange: () => {},
};

export default Checkbox;
